var _defs, _use;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDamdari(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    className: "q-icon",
    "aria-hidden": "true",
    role: "presentation",
    viewBox: "0 0 24 24",
    "data-v-5ea012e0": "",
    width: 50,
    height: 50,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "farm-outline",
    width: "100%",
    height: "100%",
    viewBox: "0 0 128 128"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.48,110.73l-3.15-1.54-3,1.47L41.69,110l-2.56.66L36,108.32l-3.15,2.34L30.33,110l-2.71.66-3-1.47-3.15,1.54H19.63l-3.52-4.25-5,4.25H9v2.93h5l2.12-2.56,2.2,2.56h3.81l2.49-1.17,2.71,1.32,3-.73,3.15.73L36,112l2.56,1.83,3.15-.73,3,.73,2.64-1.32,2.49,1.17h5.57v-2.93Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.45,110.73h7.47v2.93h-7.47Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6,27.92V39.65H50.33V27.92Zm14.8,8.79H35.53V30.85H47.4Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116,54.09v4.18h-4.18V54.09h-2.93v4.18h-4.18V54.09h-2.93v4.18H97.6V54.09H94.67v4.18H90.49V54H87.56v4.25H83.38V54H80.45v4.25H76.28V54H73.35v4.32H69.17V51.15h5.06V49.69c0-17.88-14.58-39.5-32.61-39.5S9,31.81,9,49.69v1.47h5.06V75.63H40.73l1.17-.37L45,72.7H35.16l6.6-6.45,4.91,5,2.27-1.91L43.88,64.2,50.26,58V68.3l2.93-2.49V52.91H30.11V72.7H17V49.84c0-14.14,11.36-31.51,24.62-31.51s24.62,17.3,24.62,31.51V62.51h2.93V61.27h4.18v1.32h2.93V61.27h4.18v1.32h2.93V61.27h4.18v1.32h2.93V61.27h4.18v1.39H97.6V61.27h4.18v1.39h3V61.34H109V64a10.88,10.88,0,0,1,2.93,2.27V61.34h4.18v13H119V54.09ZM48.13,55.84l-6.3,6.23-6.16-6.23ZM33,57.46l6.6,6.67L33,70.65Zm36.13-9.23a40.74,40.74,0,0,0-7.91-21.11c-5.5-7.55-12.53-11.65-19.64-11.65S27.47,19.64,22,27.12a41.28,41.28,0,0,0-7.84,21.11h-2.2c.73-16.27,13.7-35.1,29.68-35.1S70.56,32,71.29,48.22Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.18,109.56H90.71l3.22-9.23-1.32-1.91L90.05,97.1h-2l2.64,3.66-4.18,11.73h7.69l4.1-11.14L95.7,100Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.54,109.56H71.07L67.48,98.72l-.37.59v7.62l1.83,5.57h7.62L71.66,97.1H68.58Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.82,83.18V73.51a8.08,8.08,0,0,0-8.06-8.06h-43a7.74,7.74,0,0,0-5,1.83L43.3,77.83l-9.09,2.71a2,2,0,0,0-1.47,1.76,2.21,2.21,0,0,0,1.1,2.05l.73.37-.66,1a3,3,0,0,0-.51,1.91l.15.88A30.58,30.58,0,0,1,33.41,97L33,99.89a2.09,2.09,0,0,0,1.47,2.27l3.37,1a2.24,2.24,0,0,0,1.69-.22l1.61-1a23,23,0,0,0,6.52-6.23h7.69l3.08,3.74v14.14h7.25V98.72l2.12-3.15H90.42l10.77,5.5v12.6h7.33V99.3a3.72,3.72,0,0,0-.22-1.25l-3-9.09,1.91-6.82a9.81,9.81,0,0,0,.44-2.93v-9a4.85,4.85,0,0,1,1.25,3.3v9.67a8.31,8.31,0,0,0-2,5.35,8.15,8.15,0,0,0,2.42,5.79l1,1,1-1a8.15,8.15,0,0,0,2.42-5.79,8.46,8.46,0,0,0-2-5.35ZM104.71,69.4V79.3a7.1,7.1,0,0,1-.29,2.12L102.22,89l3.3,9.89c0,.07.07.22.07.29v11.43h-1.47V99.23l-13-6.6H66.16l-3.52,5.2v12.82H61.25V98.42l-4.62-5.57H46l-.44.66a18.6,18.6,0,0,1-6,5.94l-1.32.81L36,99.6l.37-2.05a31,31,0,0,0,.15-9.38l-.07-.73a.27.27,0,0,1,.07-.22l2.34-3.66-1.69-.88,7.69-2.27,12.9-10.92a4.66,4.66,0,0,1,3.08-1.1h43a1.1,1.1,0,0,1,.88,1Zm5.64,21.4a5.29,5.29,0,0,1,0-4.54,4.91,4.91,0,0,1,.51,2.27A6,6,0,0,1,110.35,90.8Z",
    transform: "translate(0 0)"
  })))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#farm-outline",
    fill: "#525957"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDamdari);
export default __webpack_public_path__ + "static/media/damdari.4cb40f2c3df04c4fb167b08a68fd1a50.svg";
export { ForwardRef as ReactComponent };